import React from "react";
import PropTypes from "prop-types";
import "./skills.scss";
import skillsDataJson from "../../../data/skills.json";

// Category SVG Icons
const CodeIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <polyline points="16 18 22 12 16 6" />
        <polyline points="8 6 2 12 8 18" />
    </svg>
);

const TerminalIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <polyline points="4 17 10 11 4 5" />
        <line x1="12" y1="19" x2="20" y2="19" />
    </svg>
);

const ShieldIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <path d="M9 12l2 2 4-4" />
    </svg>
);

const SmartphoneIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
        <line x1="12" y1="18" x2="12.01" y2="18" />
    </svg>
);

const ZapIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
    </svg>
);

// Colorful Brand Skill Icons (smaller, 18x18)
const skillIcons = {
    // Web Design - Figma
    webDesign: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 38 57"
            width="18"
            height="18"
        >
            <path
                fill="#19bcfe"
                d="M19 28.5a9.5 9.5 0 1 1 19 0 9.5 9.5 0 0 1-19 0z"
            />
            <path
                fill="#0acf83"
                d="M0 47.5A9.5 9.5 0 0 0 9.5 57 9.5 9.5 0 0 0 19 47.5V38H9.5a9.5 9.5 0 0 0-9.5 9.5z"
            />
            <path fill="#ff7262" d="M19 0v19h9.5a9.5 9.5 0 1 0 0-19H19z" />
            <path
                fill="#f24e1e"
                d="M0 9.5a9.5 9.5 0 0 0 9.5 9.5H19V0H9.5A9.5 9.5 0 0 0 0 9.5z"
            />
            <path
                fill="#a259ff"
                d="M0 28.5a9.5 9.5 0 0 0 9.5 9.5H19V19H9.5A9.5 9.5 0 0 0 0 28.5z"
            />
        </svg>
    ),
    // Flutter
    flutter: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            id="flutter"
            width="18"
            height="18"
        >
            <path
                fill="#42A5F5"
                fillOpacity=".8"
                d="m6 15.695-3.696-3.696L14.305 0h7.391L6 15.695zm15.695-4.622h-7.391l-2.768 2.768 3.696 3.696 6.463-6.464z"
            ></path>
            <path
                fill="#0D47A1"
                d="M11.536 21.232 14.305 24h7.391l-6.463-6.463-3.697 3.695z"
            ></path>
            <path
                fill="#42A5F5"
                d="m7.849 17.539 3.69-3.691 3.69 3.69-3.69 3.691-3.69-3.69z"
            ></path>
            <linearGradient
                id="a"
                x1="-2075.633"
                x2="-2075.633"
                y1="-1590.528"
                y2="-1590.518"
                gradientTransform="matrix(380.4042 -380.4175 53.104 53.1021 874056.25 -705127.375)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset=".2" stopOpacity=".15"></stop>
                <stop offset=".85" stopColor="#616161" stopOpacity=".01"></stop>
            </linearGradient>
            <path
                fill="url(#a)"
                d="m11.539 21.229 3.69-3.69.515.515-3.69 3.69-.515-.515z"
            ></path>
            <linearGradient
                id="b"
                x1="-2078.999"
                x2="-2078.99"
                y1="-1580.155"
                y2="-1580.155"
                gradientTransform="matrix(565.291 0 0 380.9571 1175251.25 601990.813)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset=".2" stopOpacity=".55"></stop>
                <stop offset=".85" stopColor="#616161" stopOpacity=".01"></stop>
            </linearGradient>
            <path
                fill="url(#b)"
                d="m11.536 21.232 5.483-1.894-1.788-1.801-3.695 3.695z"
            ></path>
        </svg>
    ),
    // JavaScript
    javascript: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 256 256"
            width="18"
            height="18"
        >
            <g fill="none">
                <rect width="256" height="256" fill="#F0DB4F" rx="60"></rect>
                <path
                    fill="#323330"
                    d="m67.312 213.932l19.59-11.856c3.78 6.701 7.218 12.371 15.465 12.371c7.905 0 12.889-3.092 12.889-15.12v-81.798h24.058v82.138c0 24.917-14.606 36.259-35.916 36.259c-19.245 0-30.416-9.967-36.087-21.996m85.07-2.576l19.588-11.341c5.157 8.421 11.859 14.607 23.715 14.607c9.969 0 16.325-4.984 16.325-11.858c0-8.248-6.53-11.17-17.528-15.98l-6.013-2.579c-17.357-7.388-28.871-16.668-28.871-36.258c0-18.044 13.748-31.792 35.229-31.792c15.294 0 26.292 5.328 34.196 19.247l-18.731 12.029c-4.125-7.389-8.591-10.31-15.465-10.31c-7.046 0-11.514 4.468-11.514 10.31c0 7.217 4.468 10.139 14.778 14.608l6.014 2.577c20.449 8.765 31.963 17.699 31.963 37.804c0 21.654-17.012 33.51-39.867 33.51c-22.339 0-36.774-10.654-43.819-24.574"
                ></path>
            </g>
        </svg>
    ),
    // React
    react: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            id="react"
            width="18"
            height="18"
            viewBox="0 0 3618.6 3618.6"
        >
            <path d="M0 0h3618.6v3618.6H0z" style={{ fill: "#222" }}></path>
            <circle
                cx="1806.5"
                cy="1807.1"
                r="302.6"
                style={{ fill: "#00d8ff" }}
            ></circle>
            <path
                d="M1806.5 1191.9c406.2 0 783.6 58.3 1068.1 156.2 342.8 118 553.6 296.9 553.6 458.9 0 168.8-223.4 358.9-591.5 480.8-278.3 92.2-644.6 140.4-1030.2 140.4-395.4 0-769.7-45.2-1051.2-141.4-356.1-121.7-570.6-314.2-570.6-479.8 0-160.7 201.3-338.2 539.3-456 285.6-99.5 672.3-159.1 1082.5-159.1z"
                style={{
                    fill: "none",
                    stroke: "#00d8ff",
                    strokeMiterlimit: 10,
                    strokeWidth: 144.7456,
                }}
            ></path>
            <path
                d="M1271 1501.3c202.9-351.9 442-649.7 669-847.2 273.5-238 533.8-331.2 674.1-250.3 146.2 84.3 199.3 372.8 121 752.7-59.2 287.2-200.4 628.5-393.1 962.6-197.5 342.5-423.7 644.2-647.6 840-283.3 247.7-557.3 337.3-700.7 254.6-139.2-80.3-192.4-343.3-125.7-695 56.4-297.4 198-662.1 403-1017.4z"
                style={{
                    fill: "none",
                    stroke: "#00d8ff",
                    strokeMiterlimit: 10,
                    strokeWidth: 144.7456,
                }}
            ></path>
            <path
                d="M1271.5 2119.8c-203.5-351.6-342.1-707.4-399.9-1002.7-69.6-355.8-20.4-627.9 119.8-709 146.1-84.6 422.5 13.5 712.5 271 219.3 194.7 444.4 487.5 637.6 821.3 198.1 342.2 346.6 688.8 404.3 980.5 73.1 369.2 13.9 651.3-129.4 734.2-139.1 80.5-393.5-4.7-664.9-238.2-229.2-197.3-474.5-502.1-680-857.1z"
                style={{
                    fill: "none",
                    stroke: "#00d8ff",
                    strokeMiterlimit: 10,
                    strokeWidth: 144.7456,
                }}
            ></path>
        </svg>
    ),
    // C++
    cpp: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            width="18"
            height="18"
        >
            <path
                fill="#659ad2"
                d="M29 10.232a2.4 2.4 0 0 0-.318-1.244a2.45 2.45 0 0 0-.936-.879q-5.194-2.868-10.393-5.733a2.64 2.64 0 0 0-2.763.024c-1.378.779-8.275 4.565-10.331 5.706A2.29 2.29 0 0 0 3 10.231V21.77a2.4 2.4 0 0 0 .3 1.22a2.43 2.43 0 0 0 .954.9c2.056 1.141 8.954 4.927 10.332 5.706a2.64 2.64 0 0 0 2.763.026q5.19-2.871 10.386-5.733a2.44 2.44 0 0 0 .955-.9a2.4 2.4 0 0 0 .3-1.22V10.232"
            ></path>
            <path
                fill="#00599c"
                d="M28.549 23.171a2 2 0 0 0 .147-.182a2.4 2.4 0 0 0 .3-1.22V10.232a2.4 2.4 0 0 0-.318-1.244c-.036-.059-.089-.105-.13-.16L16 16Z"
            ></path>
            <path
                fill="#004482"
                d="M28.549 23.171L16 16L3.451 23.171a2.4 2.4 0 0 0 .809.72c2.056 1.141 8.954 4.927 10.332 5.706a2.64 2.64 0 0 0 2.763.026q5.19-2.871 10.386-5.733a2.4 2.4 0 0 0 .808-.719"
            ></path>
            <path
                fill="#fff"
                d="M19.6 18.02a4.121 4.121 0 1 1-.027-4.087l3.615-2.073A8.309 8.309 0 0 0 7.7 16a8.2 8.2 0 0 0 1.1 4.117a8.319 8.319 0 0 0 14.411-.017z"
            ></path>
            <path
                fill="#fff"
                d="M24.076 15.538h-.926v-.921h-.925v.921h-.926v.923h.926v.92h.925v-.92h.926zm3.473 0h-.926v-.921h-.926v.921h-.926v.923h.926v.92h.926v-.92h.926z"
            ></path>
        </svg>
    ),
    // Python
    python: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 128 128"
            width="18"
            height="18"
        >
            <linearGradient
                id="deviconOriginalPython0"
                x1="70.252"
                x2="170.659"
                y1="1237.476"
                y2="1151.089"
                gradientTransform="matrix(.563 0 0 -.568 -29.215 707.817)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#5A9FD4"></stop>
                <stop offset="1" stopColor="#306998"></stop>
            </linearGradient>
            <linearGradient
                id="deviconOriginalPython1"
                x1="209.474"
                x2="173.62"
                y1="1098.811"
                y2="1149.537"
                gradientTransform="matrix(.563 0 0 -.568 -29.215 707.817)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#FFD43B"></stop>
                <stop offset="1" stopColor="#FFE873"></stop>
            </linearGradient>
            <path
                fill="url(#deviconOriginalPython0)"
                d="M63.391 1.988c-4.222.02-8.252.379-11.8 1.007c-10.45 1.846-12.346 5.71-12.346 12.837v9.411h24.693v3.137H29.977c-7.176 0-13.46 4.313-15.426 12.521c-2.268 9.405-2.368 15.275 0 25.096c1.755 7.311 5.947 12.519 13.124 12.519h8.491V67.234c0-8.151 7.051-15.34 15.426-15.34h24.665c6.866 0 12.346-5.654 12.346-12.548V15.833c0-6.693-5.646-11.72-12.346-12.837c-4.244-.706-8.645-1.027-12.866-1.008zM50.037 9.557c2.55 0 4.634 2.117 4.634 4.721c0 2.593-2.083 4.69-4.634 4.69c-2.56 0-4.633-2.097-4.633-4.69c-.001-2.604 2.073-4.721 4.633-4.721z"
                transform="translate(0 10.26)"
            ></path>
            <path
                fill="url(#deviconOriginalPython1)"
                d="M91.682 28.38v10.966c0 8.5-7.208 15.655-15.426 15.655H51.591c-6.756 0-12.346 5.783-12.346 12.549v23.515c0 6.691 5.818 10.628 12.346 12.547c7.816 2.297 15.312 2.713 24.665 0c6.216-1.801 12.346-5.423 12.346-12.547v-9.412H63.938v-3.138h37.012c7.176 0 9.852-5.005 12.348-12.519c2.578-7.735 2.467-15.174 0-25.096c-1.774-7.145-5.161-12.521-12.348-12.521h-9.268zM77.809 87.927c2.561 0 4.634 2.097 4.634 4.692c0 2.602-2.074 4.719-4.634 4.719c-2.55 0-4.633-2.117-4.633-4.719c0-2.595 2.083-4.692 4.633-4.692z"
                transform="translate(0 10.26)"
            ></path>
            <radialGradient
                id="deviconOriginalPython2"
                cx="1825.678"
                cy="444.45"
                r="26.743"
                gradientTransform="matrix(0 -.24 -1.055 0 532.979 557.576)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#B8B8B8" stopOpacity=".498"></stop>
                <stop offset="1" stopColor="#7F7F7F" stopOpacity="0"></stop>
            </radialGradient>
            <path
                fill="url(#deviconOriginalPython2)"
                d="M97.309 119.597c0 3.543-14.816 6.416-33.091 6.416c-18.276 0-33.092-2.873-33.092-6.416c0-3.544 14.815-6.417 33.092-6.417c18.275 0 33.091 2.872 33.091 6.417z"
                opacity=".444"
            ></path>
        </svg>
    ),
    // Java
    java: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 128 128"
            width="18"
            height="18"
        >
            <path
                fill="#0074BD"
                d="M52.581 67.817s-3.284 1.911 2.341 2.557c6.814.778 10.297.666 17.805-.753c0 0 1.979 1.237 4.735 2.309c-16.836 7.213-38.104-.418-24.881-4.113zm-2.059-9.415s-3.684 2.729 1.945 3.311c7.28.751 13.027.813 22.979-1.103c0 0 1.373 1.396 3.536 2.157c-20.352 5.954-43.021.469-28.46-4.365z"
            ></path>
            <path
                fill="#EA2D2E"
                d="M67.865 42.431c4.151 4.778-1.088 9.074-1.088 9.074s10.533-5.437 5.696-12.248c-4.519-6.349-7.982-9.502 10.771-20.378c.001 0-29.438 7.35-15.379 23.552z"
            ></path>
            <path
                fill="#0074BD"
                d="M90.132 74.781s2.432 2.005-2.678 3.555c-9.716 2.943-40.444 3.831-48.979.117c-3.066-1.335 2.687-3.187 4.496-3.576c1.887-.409 2.965-.334 2.965-.334c-3.412-2.403-22.055 4.719-9.469 6.762c34.324 5.563 62.567-2.506 53.665-6.524zm-35.97-26.134s-15.629 3.713-5.534 5.063c4.264.57 12.758.439 20.676-.225c6.469-.543 12.961-1.704 12.961-1.704s-2.279.978-3.93 2.104c-15.874 4.175-46.533 2.23-37.706-2.038c7.463-3.611 13.533-3.2 13.533-3.2zM82.2 64.317c16.135-8.382 8.674-16.438 3.467-15.353c-1.273.266-1.845.496-1.845.496s.475-.744 1.378-1.063c10.302-3.62 18.223 10.681-3.322 16.345c0 0 .247-.224.322-.425z"
            ></path>
            <path
                fill="#EA2D2E"
                d="M72.474 1.313s8.935 8.939-8.476 22.682c-13.962 11.027-3.184 17.313-.006 24.498c-8.15-7.354-14.128-13.828-10.118-19.852c5.889-8.842 22.204-13.131 18.6-27.328z"
            ></path>
            <path
                fill="#0074BD"
                d="M55.749 87.039c15.484.99 39.269-.551 39.832-7.878c0 0-1.082 2.777-12.799 4.981c-13.218 2.488-29.523 2.199-39.191.603c0 0 1.98 1.64 12.158 2.294z"
            ></path>
            <path
                fill="#EA2D2E"
                d="M94.866 100.181h-.472v-.264h1.27v.264h-.47v1.317h-.329l.001-1.317zm2.535.066h-.006l-.468 1.251h-.216l-.465-1.251h-.005v1.251h-.312v-1.581h.457l.431 1.119l.432-1.119h.454v1.581h-.302v-1.251zm-44.19 14.79c-1.46 1.266-3.004 1.978-4.391 1.978c-1.974 0-3.045-1.186-3.045-3.085c0-2.055 1.146-3.56 5.738-3.56h1.697v4.667h.001zm4.031 4.548v-14.077c0-3.599-2.053-5.973-6.997-5.973c-2.886 0-5.416.714-7.473 1.622l.592 2.493c1.62-.595 3.715-1.147 5.771-1.147c2.85 0 4.075 1.147 4.075 3.521v1.779h-1.424c-6.921 0-10.044 2.685-10.044 6.723c0 3.479 2.058 5.456 5.933 5.456c2.49 0 4.351-1.028 6.088-2.533l.316 2.137h3.163v-.001zm13.452 0h-5.027l-6.051-19.689h4.391l3.756 12.099l.835 3.635c1.896-5.258 3.24-10.596 3.912-15.733h4.271c-1.143 6.481-3.203 13.598-6.087 19.688zm19.288-4.548c-1.465 1.266-3.01 1.978-4.392 1.978c-1.976 0-3.046-1.186-3.046-3.085c0-2.055 1.149-3.56 5.736-3.56h1.701v4.667h.001zm4.033 4.548v-14.077c0-3.599-2.059-5.973-6.999-5.973c-2.889 0-5.418.714-7.475 1.622l.593 2.493c1.62-.595 3.718-1.147 5.774-1.147c2.846 0 4.074 1.147 4.074 3.521v1.779h-1.424c-6.923 0-10.045 2.685-10.045 6.723c0 3.479 2.056 5.456 5.93 5.456c2.491 0 4.349-1.028 6.091-2.533l.318 2.137h3.163v-.001zm-56.693 3.346c-1.147 1.679-3.005 3.008-5.037 3.757l-1.989-2.345c1.547-.794 2.872-2.075 3.489-3.269c.532-1.063.753-2.43.753-5.701V92.891h4.284v22.173c0 4.375-.348 6.144-1.5 7.867z"
            ></path>
        </svg>
    ),
    // React Native
    reactNative: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            id="react-native"
            width="18"
            height="18"
            viewBox="0 0 3618.6 3618.6"
        >
            <path d="M0 0h3618.6v3618.6H0z" style={{ fill: "#222" }}></path>
            <circle
                cx="1806.5"
                cy="1807.1"
                r="302.6"
                style={{ fill: "#00d8ff" }}
            ></circle>
            <path
                d="M1806.5 1191.9c406.2 0 783.6 58.3 1068.1 156.2 342.8 118 553.6 296.9 553.6 458.9 0 168.8-223.4 358.9-591.5 480.8-278.3 92.2-644.6 140.4-1030.2 140.4-395.4 0-769.7-45.2-1051.2-141.4-356.1-121.7-570.6-314.2-570.6-479.8 0-160.7 201.3-338.2 539.3-456 285.6-99.5 672.3-159.1 1082.5-159.1z"
                style={{
                    fill: "none",
                    stroke: "#00d8ff",
                    strokeMiterlimit: 10,
                    strokeWidth: 144.7456,
                }}
            ></path>
            <path
                d="M1271 1501.3c202.9-351.9 442-649.7 669-847.2 273.5-238 533.8-331.2 674.1-250.3 146.2 84.3 199.3 372.8 121 752.7-59.2 287.2-200.4 628.5-393.1 962.6-197.5 342.5-423.7 644.2-647.6 840-283.3 247.7-557.3 337.3-700.7 254.6-139.2-80.3-192.4-343.3-125.7-695 56.4-297.4 198-662.1 403-1017.4z"
                style={{
                    fill: "none",
                    stroke: "#00d8ff",
                    strokeMiterlimit: 10,
                    strokeWidth: 144.7456,
                }}
            ></path>
            <path
                d="M1271.5 2119.8c-203.5-351.6-342.1-707.4-399.9-1002.7-69.6-355.8-20.4-627.9 119.8-709 146.1-84.6 422.5 13.5 712.5 271 219.3 194.7 444.4 487.5 637.6 821.3 198.1 342.2 346.6 688.8 404.3 980.5 73.1 369.2 13.9 651.3-129.4 734.2-139.1 80.5-393.5-4.7-664.9-238.2-229.2-197.3-474.5-502.1-680-857.1z"
                style={{
                    fill: "none",
                    stroke: "#00d8ff",
                    strokeMiterlimit: 10,
                    strokeWidth: 144.7456,
                }}
            ></path>
        </svg>
    ),
    // Ethical Hacking - Kali Linux
    ethicalHacking: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            width="18"
            height="18"
        >
            <path
                fill="#539CCE"
                d="M11.96 28.526s-1.897 1.458-1.579 2.187c3.921-.766 8.019-1.094 13.439.035c-.911-3.245-4.337-12.871-6.195-15.167c-1.75-2.115-4.41-3.646-6.195-4.048c-1.786-.401-4.701-1.021-9.986.365c-2.88 1.896.766 3.646 1.494 3.755c3.208 2.079 5.323-2.224 6.818-1.786s.765 1.422-.328 1.495c-1.094.073-2.114.765-2.479 2.078c-.365 1.313 1.312 2.662 1.312 2.662s-2.15-.292-2.916 1.313c-.766 1.604 1.276 2.37 1.276 2.37s-1.422-.438-1.786.875c-.237.857.265 1.55.932 1.951c.323.23.149.919.149.919s-1.312.292-1.969 1.714c-1.385 2.917 1.714 3.318 3.792 2.917c.547-.109 4.192-3.646 4.192-3.646z"
            />
            <path
                fill="#000"
                d="M16.953 1.286S7.948 1.214 3.974 9.417c-2.37 4.995 1.057 14.656 1.057 14.656S2.151 22.396 2.48 18.276c.328-4.229 2.807-10.427 9.114-14.474c6.307-4.047 16.734-.875 16.734-.875S19.531 1.76 16.953 1.286z"
            />
        </svg>
    ),
    // Mobile Hacking - Android
    mobileHacking: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            width="18"
            height="18"
        >
            <path
                fill="#3DDC84"
                d="M22.09 9.39L23.75 6.51C23.86 6.32 23.79 6.08 23.6 5.97C23.41 5.86 23.17 5.93 23.06 6.12L21.37 9.05C19.75 8.31 17.93 7.89 16 7.89C14.07 7.89 12.25 8.31 10.63 9.05L8.94 6.12C8.83 5.93 8.59 5.87 8.4 5.97C8.21 6.08 8.14 6.32 8.25 6.51L9.91 9.39C7.03 10.97 5 13.9 4.79 17.33H27.22C27 13.9 24.97 10.97 22.09 9.39ZM10.5 14C9.95 14 9.5 13.55 9.5 13C9.5 12.45 9.95 12 10.5 12C11.05 12 11.5 12.45 11.5 13C11.5 13.55 11.05 14 10.5 14ZM21.5 14C20.95 14 20.5 13.55 20.5 13C20.5 12.45 20.95 12 21.5 12C22.05 12 22.5 12.45 22.5 13C22.5 13.55 22.05 14 21.5 14Z"
            />
            <path
                fill="#3DDC84"
                d="M5 19H27V26C27 28.21 25.21 30 23 30H9C6.79 30 5 28.21 5 26V19Z"
            />
        </svg>
    ),
    // Network Security - Server/Cloud
    networkSecurity: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="18"
            height="18"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ color: "#60A5FA" }}
        >
            <rect x="2" y="2" width="20" height="8" rx="2" ry="2" />
            <rect x="2" y="14" width="20" height="8" rx="2" ry="2" />
            <line x1="6" y1="6" x2="6.01" y2="6" />
            <line x1="6" y1="18" x2="6.01" y2="18" />
        </svg>
    ),
    // Node.js
    nodejs: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            width="18"
            height="18"
        >
            <path
                fill="#339933"
                d="M16,0.003C15.548,0.003,15.112,0.25,14.87,0.648L0.12,24.96c-0.24,0.398-0.24,0.898,0,1.297l14.75,24.313 c0.242,0.398,0.678,0.645,1.13,0.645s0.888-0.246,1.13-0.645l14.75-24.313c0.24-0.398,0.24-0.898,0-1.297L17.13,0.648 C16.888,0.25,16.452,0.003,16,0.003z"
                transform="scale(0.6) translate(15,8)"
            />
            <path
                fill="#66CC33"
                d="M16,2L2.5,25L16,48L29.5,25L16,2z"
                transform="scale(0.0) translate(0,0)"
            />
            <path
                d="M16 2 L2.5 9.5 L2.5 24.5 L16 32 L29.5 24.5 L29.5 9.5 Z"
                fill="#339933"
            />
            <path
                d="M16 4 L4.5 10.5 L4.5 23.5 L16 30 L27.5 23.5 L27.5 10.5 Z"
                fill="#339933"
            />
            <path
                d="M17 9 L13 9 L13 20 L22 20 L22 17 L16 17 L16 14 L21 14 L21 11 L17 11 Z"
                fill="#FFFFFF"
            />
        </svg>
    ),
    // Express.js
    express: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 256 256"
            width="18"
            height="18"
        >
            <g fill="none">
                <rect width="256" height="256" fill="#F4F2ED" rx="60"></rect>
                <path
                    fill="#0F0F0F"
                    d="M228 182.937a12.73 12.73 0 0 1-15.791-6.005c-9.063-13.567-19.071-26.522-28.69-39.755l-4.171-5.56c-11.454 15.346-22.908 30.08-33.361 45.371a12.23 12.23 0 0 1-15.012 5.894l42.98-57.659l-39.978-52.1a13.29 13.29 0 0 1 15.847 5.56c9.285 13.568 19.572 26.523 29.802 40.257c10.287-13.623 20.462-26.634 29.97-40.09a11.95 11.95 0 0 1 14.901-5.56l-15.513 20.573c-6.95 9.174-13.789 18.404-21.017 27.356a5.56 5.56 0 0 0 0 8.285c13.289 17.626 26.466 35.307 40.033 53.433M28 124.5c1.168-5.56 1.89-11.621 3.503-17.292c9.619-34.195 48.818-48.43 75.785-27.245c15.791 12.4 19.739 29.97 18.961 49.764H37.286c-1.446 35.363 24.075 56.714 56.713 45.816a33.86 33.86 0 0 0 21.518-23.965c1.724-5.56 4.504-6.505 9.786-4.893a45.15 45.15 0 0 1-21.573 32.972a52.26 52.26 0 0 1-60.884-7.784a54.77 54.77 0 0 1-13.678-32.138c0-1.89-.723-3.781-1.112-5.56A861 861 0 0 1 28 124.5m9.397-2.391h80.456c-.501-25.632-16.681-43.814-38.254-43.98c-24.02-.334-41.201 17.458-42.258 43.869z"
                ></path>
            </g>
        </svg>
    ),
};

// Skills data organized by categories
// Map string keys from JSON to Icon Components
const categoryIcons = {
    code: <CodeIcon />,
    terminal: <TerminalIcon />,
    shield: <ShieldIcon />,
    smartphone: <SmartphoneIcon />,
};

// Transform JSON data to match the component structure
const skillsData = Object.keys(skillsDataJson).reduce((acc, key) => {
    const category = skillsDataJson[key];
    acc[key] = {
        ...category,
        icon: categoryIcons[category.icon],
        skills: category.skills.map((skill) => ({
            ...skill,
            icon: skillIcons[skill.icon],
        })),
    };
    return acc;
}, {});

// Skill Card Component
const SkillCard = ({ category, data, index }) => {
    return (
        <div
            className="skill-card"
            style={{ "--card-color": data.color, "--delay": `${index * 0.1}s` }}
        >
            <div className="skill-card__header">
                <div className="skill-card__icon">{data.icon}</div>
                <h3 className="skill-card__title">{data.title}</h3>
            </div>
            <div className="skill-card__body">
                {data.skills.map((skill, idx) => (
                    <div
                        className="skill-item"
                        key={idx}
                        style={{ "--skill-delay": `${idx * 0.15}s` }}
                    >
                        <div className="skill-item__header">
                            <div className="skill-item__info">
                                <span className="skill-item__icon">
                                    {skill.icon}
                                </span>
                                <span className="skill-item__name">
                                    {skill.name}
                                </span>
                            </div>
                            <span className="skill-item__level">
                                {skill.level}%
                            </span>
                        </div>
                        <div className="skill-item__bar">
                            <div
                                className="skill-item__progress"
                                style={{ "--progress": `${skill.level}%` }}
                            >
                                <div className="skill-item__glow"></div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

SkillCard.propTypes = {
    category: PropTypes.string,
    data: PropTypes.shape({
        title: PropTypes.string,
        color: PropTypes.string,
        icon: PropTypes.node,
        skills: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
                level: PropTypes.number,
                icon: PropTypes.node,
            })
        ),
    }).isRequired,
    index: PropTypes.number,
};

const SkillContainer = () => {
    return (
        <section className="section skills-section">
            <div className="container">
                {/* Section Header */}
                <div className="skills-header">
                    <div className="skills-header__badge">
                        <ZapIcon />
                        <span>Technical Expertise</span>
                    </div>
                    <h2 className="skills-header__title">
                        Skills & <span>Proficiency</span>
                    </h2>
                    <p className="skills-header__subtitle">
                        A comprehensive overview of my technical abilities and
                        expertise levels
                    </p>
                </div>

                {/* Skills Grid */}
                <div className="skills-grid">
                    {Object.entries(skillsData).map(([key, data], index) => (
                        <SkillCard
                            key={key}
                            category={key}
                            data={data}
                            index={index}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default SkillContainer;
